export default "__VITE_ASSET__77b5f0b2__"